<template>
  <div>
      <Header :home=false :logged="logged" />
        <b-modal ref="modalPdf" size="xl" scrollable title="Procuração PDF" id="modal-dialog" @show="desableRC">
          <pdf  :src="this.pdf" style="width:100%"></pdf>
        </b-modal>
        <div id="painel" class="container-fluid">
          <b-row>
              <b-col cols="12" md="4" lg="2" v-if="show" style="padding: 0;" >
                  <Menu class="d-none d-xl-block" />
              </b-col>
              <b-col cols="10" md="10" lg="10" class="flex">
                  <b-container fluid>
                      <h4 class="text-primary mt-5">Pesquisar Procuração</h4>
                      <div>
                        <b-button v-b-toggle.collapse-1 variant="primary"> <font-awesome-icon icon="search"/>  Faça sua pesquisa</b-button>
                        <b-collapse id="collapse-1" class="mt-2">
                          <b-card>
                            <p class="card-text">Informe sua pesquisa</p>
                            <!-- formulario de pesquisar -->
                            <div>
                              <b-form name="frmBuscarProcuracao" id="frmBuscarProcuracao">
                                <b-row>
                                    <b-col cols="12" md="4" lg="2" >
                                      <b-form-group
                                        id="vigenciaInicial"
                                        label="Vigência Inicial"
                                        label-for="input-1"
                                        description="Data inicial da vigencia"
                                      >
                                        <b-form-input
                                          id="ViginciaInicial"
                                          v-model="form.ViginciaInicial"
                                          type="date"
                                          required
                                        ></b-form-input>
                                      </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="4" lg="2">
                                      <b-form-group
                                        id="vigenciaFinal"
                                        label="Vigência Final"
                                        label-for="input-1"
                                        description="Data Final da vigência"
                                      >
                                        <b-form-input
                                          id="ViginciaFinal"
                                          v-model="form.ViginciaFinal"
                                          type="date"
                                          required
                                        ></b-form-input>
                                      </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6" lg="4">
                                      <b-form-group id="input-group-2" label="Nome Outorgado:" label-for="input-2">
                                        <b-form-input
                                          id="input-2"
                                          v-model="form.nome"
                                          placeholder="Nome do Outorgado"
                                        ></b-form-input>
                                      </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6" lg="2">
                                      <b-form-group id="input-group-2" label="Documento Outorgado:" label-for="input-2">
                                        <b-form-input
                                          id="input-2"
                                          v-model="form.documento"
                                          maxlength="18"
                                          placeholder="Documento"
                                          @keyup="documento"
                                        ></b-form-input>
                                      </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="2" lg="2">
                                      <b-form-group id="input-group-3" label="Status:" label-for="input-3">
                                        <b-form-select
                                          id="input-3"
                                          v-model="form.status"
                                          :options="foods"
                                        ></b-form-select>
                                      </b-form-group>
                                    </b-col>

                                  </b-row>

                                <b-button @click="buscar" type="button" variant="primary"><font-awesome-icon icon="search"/> Buscar</b-button>
                              </b-form>
                            </div>
                          </b-card>
                        </b-collapse>
                      </div>
                      <br>
                      <div>
                        <b-table
                        id="my-table-pesquisar"
                        :items="items"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :fields="fields"
                        stacked="sm"
                        striped hover responsive="sm" >
                        <!-- formata o documento -->
                        <template slot="outorgado_documento" slot-scope="row">
                          {{ row.item.outorgado_documento | documento}}
                        </template>
                        <template slot="actions" slot-scope="row">
                          <b-button variant="info" size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                            <font-awesome-icon icon="eye"/>
                          </b-button>
                          <b-button variant="danger" size="sm" @click="infoDeletar(row.item, row.index, $event.target)" class="mr-1" v-if="row.item.procuracao_status_id == 1">
                            <font-awesome-icon icon="trash-alt"/>
                          </b-button>
                        </template>
                      </b-table>
                      </div>
                      <!-- Info modal -->
                      <b-modal size="lg" ref="modalDeletar" centered :id="infoModalDeletar.id" :title="infoModalDeletar.title" ok-only @hide="resetInfoModalDeletar">
                        <b-alert variant="info" show><h2> ! Deseja deletar essa procuração ? </h2> </b-alert>
                        <template v-slot:modal-footer="{ ok, cancel, hide }">
                          <b-button size="lg" variant="success" @click="deletarProcuracao(infoModalDeletar.conteudo.idProcuracao)">
                            SIM DESEJO DELETAR
                          </b-button>
                          <b-button size="lg" variant="danger" @click="cancel()">
                            Cancelar
                          </b-button>
                        </template>
                      </b-modal>
                      <!-- Info modal -->
                      <b-modal size="lg" :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true" >
                        <b-alert variant="info" show> {{ infoModal.conteudo.descricao }}</b-alert>
                        <template v-slot:modal-footer="{ok, cancel, hide}">
                          <b-button size="lg" variant="primary" @click="visualizarPDF" v-if="infoModal.conteudo.procuracao_status_id == 2">
                            Visualizar PDF 
                          </b-button>
                           <b-button size="lg" variant="primary" v-if="infoModal.conteudo.procuracao_status_id == 2" @click="downloadPDF">
                            Download PDF 
                          </b-button>
                         <b-button size="lg" variant="primary" @click="finalizar(infoModal.conteudo.idProcuracao)" v-if="infoModal.conteudo.procuracao_status_id == 1">
                            Finalizar e enviar para processamento 
                          </b-button>
                          <b-button size="lg" variant="info" @click="cancel()">
                            OK
                          </b-button>
                        </template>
                        <p><b>Período de vigência:</b> {{ infoModal.conteudo.data_vigencia_inicio | data }} à {{ infoModal.conteudo.data_vigencia_fim | data}} -
                           <b> Cadastrado em :</b> {{ infoModal.conteudo.data_cadastro | dataHora }}</p>
                        <div>
                          <b-card bg-variant="light" title="Dados do outorgado">
                            <b-card-text>
                              <p><b>Nome:</b> {{ infoModal.conteudo.outorgado_nome }} - <b>Documento:</b> {{ infoModal.conteudo.outorgado_documento }}</p>
                              <p><b>E-mail:</b> {{ infoModal.conteudo.outorgado_email }}</p>
                              <hr>
                              <p><b>Endereço:</b>{{ infoModal.conteudo.outorgado_endereco }} - <b>Nº:</b> {{ infoModal.conteudo.outorgado_numero }}
                                <b>Bairro:</b> {{ infoModal.conteudo.outorgado_bairro }} - <b>Cidade:</b> {{ infoModal.conteudo.outorgado_cidade }}
                                - <b>UF:</b> {{ infoModal.conteudo.outorgado_uf }}
                              </p>
                            </b-card-text>
                          </b-card>
                        </div>
                        <br>
                        <div>
                          <b-card bg-variant="light" title="Dados do outorgante">
                            <b-card-text>
                              <p><b>Nome:</b> {{ infoModal.conteudo.outorgante_nome }} - <b>Documento:</b> {{ infoModal.conteudo.outorgante_documento }}</p>
                              <p><b>E-mail:</b> {{ infoModal.conteudo.outorgante_email }}</p>
                              <hr>
                              <p><b>Endereço:</b>{{ infoModal.conteudo.outorgante_endereco }} - <b>Nº:</b> {{ infoModal.conteudo.outorgante_numero }}
                                <b>Bairro:</b> {{ infoModal.conteudo.outorgante_bairro }} - <b>Cidade:</b> {{ infoModal.conteudo.outorgante_cidade }}
                                - <b>UF:</b> {{ infoModal.conteudo.outorgante_uf }}
                              </p>
                            </b-card-text>
                          </b-card>
                        </div>

                        <br>
                        <div>
                          <b-card bg-variant="primary" text-variant="white" header="Atendimento Permitidas para Delegante Pessoa Jurídica:" >
                            <b-card-text>
                              <ul>
                                <li v-for="(direito, idx) in infoModal.conteudo.direitos" v-bind:key="idx">{{ direito.descricao }}</li>
                              </ul>
                            </b-card-text>
                          </b-card>
                        </div>
                      </b-modal>
                      <div class="loading">
                        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner" v-if="loading"></b-spinner>
                      </div>
                      <b-alert
                        :show="dismissCountDownDOC"
                        dismissible
                        variant="danger"
                        @dismissed="dismissCountDownDOC=0"
                        @dismiss-count-down="countDownChanged"
                      >
                        SEM DADOS - FAÇA SUA PESQUISA!
                      </b-alert>
                  </b-container>
              </b-col>
          </b-row>
      </div>
    </div>
</template>

<script>
    // import axios from "axios"
    import Header from '../../components/Header'
    import API from '../../services/api'
    import Menu from '../../template/Menu'
    import pdf from 'vue-pdf'
    //import Modal from '../../components/modal/Confmodal'


    export default {
        components: {
            Header,
            Menu,
            pdf
          //Modal,
        },
        data() {
            return {
              loading: true,
              perPage: 10,
              currentPage: 1,
              dismissSecs: 5,
              dismissCountDownDOC: 0,
              pdf : 0,
              infoModal: {
                 id: 'info-modal',
                 title: '',
                 content: '',
                 conteudo: ''
               },
               infoModalDeletar: {
                  id: 'info-modal-deletar',
                  title: '',
                  conteudo: ''
                },
              fields: [
                {
                  key: 'idProcuracao',
                  label:'ID',
                  sortable: false
                },
                {
                  key: 'outorgado_nome',
                  label:'Nome do Outorgado',
                  sortable: false
                },
                {
                  key: 'outorgado_documento',
                  label:'Documento',
                  sortable: true
                },
                {
                  key: 'data_cadastro',
                  label:'Cadastado em',
                  sortable: true
                },
                {
                  key:'descricao',
                  label: 'Status',
                  sortable: true
                },
              { key: 'actions', label: 'Ação' }],
              items: [],
              form: {
               ViginciaInicial: '',
               ViginciaFinal: '',
               nome: '',
               status: '1',
               documento: '',
               checked: []
             },
             foods: [{ text: 'Aguardando assinatura', value: '1' },{ text: 'Assinados', value: '2' }],
             show: true,
             newWindow: ''
           }
        },
         beforeCreated: function() {
           if(localStorage.getItem('libAnuenciaProc'))this.$router.push({name: "painel"});
        },
        created: function() {
         
          this.buscar();
          this.logged = true
        },
        filters: {
          dataHora: function (value) {
            if (value !== "" && value !== undefined && value !== null){
            let date = new Date(value);
            return date.toLocaleDateString("pt-BR", {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                });
            }
            return "";
          },
          data: function(value) {
            var dt = String(value)
            var dt1 = dt.split("-")
            return dt1[2]+'/'+dt1[1]+'/'+dt1[0];
          },
          documento: function (value) {
            if (value == null) {
                return '';
            } else {
                let v = value;
                //Remove tudo o que não é dígito
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    //de novo (para o segundo bloco de números)
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um hífen entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    //Coloca ponto entre o segundo e o terceiro dígitos
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                    //Coloca ponto entre o quinto e o sexto dígitos
                    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                    //Coloca uma barra entre o oitavo e o nono dígitos
                    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                    //Coloca um hífen depois do bloco de quatro dígitos
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
          }
        },
        methods: {
          async deletarProcuracao(id){
            this.loading = true
            const token = localStorage.getItem('jwtToken')
            const res = await API.delete(`procuracao/deletar/${id}/?token=${token}`)
            if(res.data == 'ok'){
              this.$refs['modalDeletar'].hide()
              this.buscar()
              this.loading = false
            }
          },
          info(item, index, button) {
            this.infoModal.title = `Detalhes da procuração: ${item.idProcuracao}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.infoModal.conteudo = item
            this.pdf = ""
            this.pdf = "data:application/pdf;base64," + item.pdfAssinado
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
          },
          infoDeletar(item, index, button) {
            this.infoModalDeletar.title = `Detalhes da procuração: ${item.idProcuracao}`
            this.infoModalDeletar.conteudo = item
            this.$root.$emit('bv::show::modal', this.infoModalDeletar.id, button)
          },
          resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
            this.infoModal.conteudo = ''
          },
          resetInfoModalDeletar() {
            this.infoModalDeletar.title = ''
            this.infoModalDeletar.conteudo = ''
          },
          countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
          },
          async buscar () {
            var self = this
            self.loading = true
            const token = localStorage.getItem('jwtToken')
            var doc = self.form.documento.replace(/\D/g, "")
            if(self.form.ViginciaInicial == ''){
              self.form.ViginciaInicial = 0
            }
            if(self.form.ViginciaFinal == ''){
              self.form.ViginciaFinal = 0
            }
            if(self.form.nome == ''){
              self.form.nome = 'sem'
            }
            if(doc == ''){
              doc = '0'
            }
            
           let cd_procuracao = ''
           
           if(localStorage.getItem('cd_procuracao') != null)
           {
             cd_procuracao = localStorage.getItem('cd_procuracao');
             localStorage.setItem('cd_procuracao', null);
           }
           
            
           const res = await API.get(`procuracao/buscar/${self.form.ViginciaInicial}/${self.form.ViginciaFinal}/${self.form.nome}/${doc}/${self.form.status}/${cd_procuracao}?token=${token}`)
            self.items = res.data
            if(res.data.length == '0'){
              this.dismissCountDownDOC = this.dismissSecs
            }
            //console.log(res.data[0])
            if(cd_procuracao>0){
              this.info(res.data[0],"0","");
            }
            self.loading = false
          },
          documento: function (event) {
            var value = event.target.value
            if (value == null) {
                return '';
            } else {
                let v = value;
                //Remove tudo o que não é dígito
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    //de novo (para o segundo bloco de números)
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um hífen entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    //Coloca ponto entre o segundo e o terceiro dígitos
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                    //Coloca ponto entre o quinto e o sexto dígitos
                    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                    //Coloca uma barra entre o oitavo e o nono dígitos
                    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                    //Coloca um hífen depois do bloco de quatro dígitos
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
                event.target.value = v;
            }
          },
          finalizar(idProcuracao) {
            const token = localStorage.getItem('jwtToken')
            //let sha256 = localStorage.getItem("nm_thumbprint_sha256")
            API.get(`procuracao/buscarAss/${idProcuracao}/?token=${token}`,).then((res) => {
              //console.log(res.data)
              this.abreJanAssinador(res.data.cd_assinador_lacuna,res.data.token)
            })
          },
          abreJanAssinador(cd_assinador_lacuna, token){
            this.PopupCenter(process.env.VUE_APP_siteAssinador+"/pki/assinarCadesPades.php?token="+token+"&nm_tipo_assinatura=pades", "janAssinador", 500, 300);
            this.checaSeAssinou(cd_assinador_lacuna, token);
          },
          PopupCenter(url, title, w, h) {
              // Fixes dual-screen position                         Most browsers      Firefox
              var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
              var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
              var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
              var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
              var systemZoom = width / window.screen.availWidth;
              var left = (width - w) / 2 / systemZoom + dualScreenLeft
              var top = (height - h) / 2 / systemZoom + dualScreenTop
              var newWindo = window.open(url, title, 'scrollbars=yes, width=' + w / systemZoom + ', height=' + h / systemZoom + ', top=' + top + ', left=' + left);
              this.newWindow = newWindo
              // Puts focus on the newWindow
              if(this.newWindow !==  null)
                if (window.focus) this.newWindow.focus();
            },
            async checaSeAssinou(cd_assinador_lacuna, token){
              var self = this
              const tokem = localStorage.getItem('jwtToken')
              const res = await API.get(`procuracao/assinar/checar/${cd_assinador_lacuna}/?token=${tokem}`)
              if(res.data[0] == 1) {
                self.loading = true
                self.buscar();
                let status = 2
                await API.put(`procuracao/atualizaStatus/${self.infoModal.conteudo.idProcuracao}/${status}?token=${tokem}`)
                self.infoModal.conteudo.descricao = 'Assinados'
                self.infoModal.conteudo.procuracao_status_id = 1
                self.loading = true
                alert('assinado com sucesso!')
                
              } else {
                var timerSeAssinou = setTimeout(function(){ self.checaSeAssinou(cd_assinador_lacuna, token); }, 1000);
                if(self.newWindow.closed){
                  self.PopupCenter(process.env.VUE_APP_siteAssinador+"/pki/assinarCadesPades.php?token="+token+"&nm_tipo_assinatura=pades", "janAssinador", 500, 300);
                  clearTimeout(timerSeAssinou);
                }
              }
          },
          desableRC() {
            var body = document.getElementsByTagName('body')[0];
            body.setAttribute('oncontextmenu','return false');
        },
        visualizarPDF(){
            this.$refs['modalPdf'].show();
        },
        downloadPDF(){
          const downloadLink = document.createElement("a");
          const fileName = "procuracao.pdf";

          downloadLink.href = this.pdf;
          downloadLink.download = fileName;
          downloadLink.click();

        },
        
      }
    }
</script>

<style scoped>
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
    #painel {
        position: fixed;
        width: 100%;
        left: 0px;
        bottom: 0px;
        padding-top: 0px;
        height: calc(100% - 80px);
        overflow-x: hidden;
    border-top: 1px solid #f1f1f1;
    }
    .lista-certidoes {
        color: #000;
    }
    .lista-certidoes b {
        font-size: 0.85rem;
        color: var(--main-azul);
    }

    a {
        color: #555;
    }
    .shadow {
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
    }
    #loading-solicitante {
        vertical-align: 0;
        margin-left: -21px;
    }
    .load{
        top: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .spin {
        background: #fff;
        height: 80px;
        width: 80px;
        border-radius: 50vh;
        border-color: #209CEE;
        border-top: 5px solid  #209CEE;
        animation: loading 3s linear infinite;
    }
    .loading{
        position: absolute;
        color: #000;
        width: 100%;
        text-align: center;
    } @keyframes loading{
        100%{
            transform: rotate(360deg)
        }
    }
    .bold{
    font-weight: bold;
    }
    .mensagemErro{
      color: red;
    }
</style>
